(() => {
  'use strict';

  const script = document.currentScript;
  const productAppLaunch = script?.dataset.productAppLaunch === 'true';

  function patchStoreBooking() {
    const originalStoreLookup = window.storeLookup;

    if (
      typeof originalStoreLookup !== 'function' ||
      originalStoreLookup.__fafRawStoresFix === true
    ) {
      return;
    }

    function patchedStoreLookup(...args) {
      const component = originalStoreLookup.apply(this, args);

      if (!component || typeof component !== 'object') {
        return component;
      }

      component.sortResultsByLocation = function sortResultsByLocation() {
        this.sortedStores = this.rawStores.map((store) => {
          store.distance = this.calcDistance(
            store.lat,
            store.lng,
            this.usersPosition.lat(),
            this.usersPosition.lng()
          );
          return store;
        }).sort((a, b) => (a.distance < b.distance ? -1 : 1));

        this.searched = true;
      };

      return component;
    }

    Object.defineProperty(patchedStoreLookup, '__fafRawStoresFix', {
      value: true
    });

    window.storeLookup = patchedStoreLookup;
  }

  function readPdpConfig() {
    const configElement = document.querySelector('[id^="PdpConfig-"]');
    if (!configElement) return {};

    try {
      return JSON.parse(configElement.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function findStoreTrigger(region) {
    if (!region) return null;

    return Array.from(region.querySelectorAll('button')).find((button) => {
      const expression = button.getAttribute('x-text') || '';
      return expression.includes('In Store: Select');
    }) || null;
  }

  function removeDiscontinuedStockistRoute() {
    const stockistLink = document.querySelector('#showOptions a[href="/pages/where-to-buy"]');
    if (!stockistLink) return;

    const previousNode = stockistLink.previousSibling;
    if (previousNode?.nodeType === Node.TEXT_NODE) {
      previousNode.textContent = previousNode.textContent.replace(/\s*or your local\s*$/i, ' ');
    }

    const inStoreLink = stockistLink.parentElement?.querySelector(
      'a[x-on\\:click\\.prevent*="show-store-stock"]'
    );

    stockistLink.remove();

    if (inStoreLink && !/\.\s*$/.test(inStoreLink.nextSibling?.textContent || '')) {
      inStoreLink.insertAdjacentText('afterend', '.');
    }
  }

  function setAcceleratedCheckoutState(variantId) {
    const region = document.querySelector('[data-native-atc-region]');
    if (!region) return;

    const paymentRegions = [
      region.querySelector('.shopify-payment-button')?.parentElement,
      region.querySelector('#cartQuickpay')
    ].filter(Boolean);

    if (!paymentRegions.length) return;

    const inactive = !variantId;

    paymentRegions.forEach((paymentRegion) => {
      if (inactive) {
        paymentRegion.setAttribute('inert', '');
        paymentRegion.setAttribute('aria-hidden', 'true');
      } else {
        paymentRegion.removeAttribute('inert');
        paymentRegion.removeAttribute('aria-hidden');
      }
    });
  }

  function patchPdp() {
    const region = document.querySelector('[data-native-atc-region]');
    if (!region) return;

    if (productAppLaunch) {
      findStoreTrigger(region)?.remove();
    }

    removeDiscontinuedStockistRoute();

    const config = readPdpConfig();
    setAcceleratedCheckoutState(String(config.initialVariantId || ''));

    window.addEventListener('variant-change', (event) => {
      const detail = event.detail || {};

      if (
        config.productId &&
        detail.productId &&
        String(detail.productId) !== String(config.productId)
      ) {
        return;
      }

      setAcceleratedCheckoutState(
        detail.variantId ? String(detail.variantId) : ''
      );
    });
  }

  patchStoreBooking();
  patchPdp();
})();
